import { connect } from "react-redux";
import VideoUploadComponent from "../components/VideoUploadComponent";
import DisplayActions from "../redux/DisplayRedux";
import UserAccountActions from "../redux/UserAccountRedux";

const mapStateToProps = ({ display, userAccount }) => ({
  user: userAccount.user,
  token: userAccount.token,
  campaignName: display.campaignName,
  campaignDescription: display.campaignDescription,
  cart: display.cart,
  defaultContent: display.defaultContent,
  creatingCampaign: display.creatingCampaign,
  editingCampaign: display.editingCampaign,
  errors: display.errors,
  campaign: display.campaign,
  client: display.client,
  brand: display.brand,
  amountBudget: display.amountBudget,
  realAmount: display.realAmount,
  defaultRules: display.defaultRules,
  programmatic: display.programmatic,
  editCampaignActive: display.editCampaignActive,
  currentCampaign: display.currentCampaign,
  customContents: display.customContents,
  loadingUploadFile: display.loadingUploadFile,
  fileNew: display.fileNew,
  canva: display.canva,
  isCampaignTest: display.isCampaignTest,
  reportSingleData: display.reportSingleData,
  currency: userAccount.currency,
  editCampaignActive: display.editCampaignActive,
  invoiceIssuingCountry: userAccount.invoiceIssuingCountry,
  audience : display.audience,
  date_from: display.date_from,
  date_to: display.date_to,
  displays: display.displays,
  dsp: display.dsp,
  isSuperUser: userAccount.isSuperUser,
  listResolutionWithContent: display.listResolutionWithContent,
  categories: display.categories,
  categoriesId: display.categoriesId,
  isSuperUser: userAccount.isSuperUser,
});

const mapStateToDispatch = dispatch => ({
  getAudience: (data) => dispatch(DisplayActions.getAudienceRequest(data)),
  setCampaignName: campaignName => dispatch(DisplayActions.setCampaignName(campaignName)),
  setCampaignDescription: campaignDescription => dispatch(DisplayActions.setCampaignDescription(campaignDescription)),
  setIsCampaignTest: isCampaignTest => dispatch(DisplayActions.setIsCampaignTest(isCampaignTest)),
  setIsCampaignPaused: isCampaignPaused => dispatch(DisplayActions.updateFieldInCustomContents(null, isCampaignPaused ? 0 : 1, "active", "multiple")),
  setDefaultContent: content => dispatch(DisplayActions.setDefaultContent(content)),
  updateDefaultContentRequest: id => dispatch(DisplayActions.updateDefaultContentRequest(id)),
  updateSubsidizedPrice: (relationId, value, typePreview) => dispatch(DisplayActions.updateFieldInCustomContents(relationId, value, "subsidized_price", typePreview)),
  clearCampaignData: id => dispatch(DisplayActions.clearCampaignData(id)),
  setDefaultRules: defaultRules => dispatch(DisplayActions.setDefaultRules(defaultRules)),
  logout: () => dispatch(UserAccountActions.userLogout()),
  setShouldPromptLogin: (value, target) => dispatch(UserAccountActions.setShouldPromptLogin(value, target)),
  uploadFileRequest: (file) => dispatch(DisplayActions.uploadFileRequest(file)),
  setCanvaInit: (canva) => dispatch(DisplayActions.setCanvaInit(canva)),
  editCampaignInactive: (campaign) => dispatch(DisplayActions.editCampaignInactive(campaign)),
  editCampaignTotalPromisedShows: (totalPromisedShows) => dispatch(DisplayActions.editCampaignTotalPromisedShows(totalPromisedShows)),
  updateRealAmount: (realAmount) => dispatch(DisplayActions.updateRealAmount(realAmount)),
  updateImpressionsDisplay: (displayId, relationId, impressions) => dispatch(DisplayActions.updateImpressionsDisplay(displayId, relationId, impressions)),
  setCategoriesId: (categoriesId) => dispatch(DisplayActions.setCategoriesId(categoriesId)),
  getCategories: () => dispatch(DisplayActions.getCategoriesRequest()),
  updateCustomContents: (customContents) => dispatch(DisplayActions.updateCustomContents(customContents)),
  userUpdate: (user) => dispatch(UserAccountActions.userUpdate(user)),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(VideoUploadComponent);
